// extracted by mini-css-extract-plugin
module.exports = {"ProfileSaved":"ProfileSaved_ProfileSaved__3CpQt","Empty":"ProfileSaved_Empty__3zZ-I","Saves":"ProfileSaved_Saves__1HKXt","Save":"ProfileSaved_Save__3JlqX"};